import {Flex} from '@chakra-ui/react';
import {CategoryList, CategorySkeleton, Section} from 'components/shared';
import {useTranslation} from 'hooks';
import React, {FC} from 'react';
import {ICategoryResponse, ProviderTypeEnum} from 'types';

const skeletonArray = new Array(13).fill(1);

interface IProps {
  isLoadingCategories: boolean;
  providerType?: ProviderTypeEnum;
  categories?: ICategoryResponse[];
}

export const CategorySlider: FC<IProps> = React.memo(({isLoadingCategories, providerType, categories}) => {
  const {t} = useTranslation();
  return (
    <Section title={t('CATEGORY_TITLE')}>
      {isLoadingCategories ? (
        <Flex overflow="hidden">
          <Flex>
            {skeletonArray.map((_, index) => (
              <CategorySkeleton key={index} />
            ))}
          </Flex>
        </Flex>
      ) : (
        <CategoryList categories={categories ?? []} providerType={providerType} isFromMainPage />
      )}
    </Section>
  );
});
